export interface Experience {
  id: string
  title: string
  copy: string
  icon:
    | 'sun'
    | 'camera'
    | 'clapper'
    | 'film'
    | 'heart'
    | 'rings'
    | 'sparkles'
    | 'plane'
    | 'mic'
    | 'play'
    | 'family'
  image?: { src: string; alt: string }
}

export const experiences: Experience[] = [
  {
    id: 'staycation',
    title: 'Staycations & hangouts',
    copy: 'Gather your people, take over the pool, and let the weekend run long — privately, and in comfort.',
    icon: 'sun',
    image: {
      src: 'https://cdn.magicpatterns.com/patterns/generated-images/5a487925-cc7d-4479-9a08-d3b331fa3eef.jpg',
      alt: 'A group of friends laughing together on a cream sofa in the apartment living room',
    },
  },
  {
    id: 'photoshoot',
    title: 'Photoshoots',
    copy: 'Architectural lines, calm interiors and natural light. Book a 3-hour session for ₦100,000.',
    icon: 'camera',
    image: {
      src: 'https://cdn.magicpatterns.com/patterns/generated-images/ee3f8718-77c7-4460-9496-88c17da9592b.jpg',
      alt: 'A model posing near an arched window during a fashion shoot inside the apartment',
    },
  },
  {
    id: 'skits',
    title: 'Skit making',
    copy: 'Rooms that read beautifully on camera without a set build — and power that never blinks mid-take.',
    icon: 'clapper',
  },
  {
    id: 'film',
    title: 'Film & video production',
    copy: 'A composed, private backdrop for scenes, music videos and brand films.',
    icon: 'film',
  },
  {
    id: 'getaway',
    title: 'Intimate getaways',
    copy: 'A quiet apartment, a slow morning, and the freedom to simply feel at home.',
    icon: 'heart',
    image: {
      src: 'https://cdn.magicpatterns.com/patterns/generated-images/32328f68-c60e-4a6f-b702-fd498cbc2fd3.jpg',
      alt: 'A couple relaxing with coffee on the terrace at golden hour',
    },
  },
  {
    id: 'prewedding',
    title: 'Pre-wedding shoots',
    copy: 'Refined interiors and a poolside setting made for golden-hour portraits.',
    icon: 'rings',
  },
  {
    id: 'bachelor',
    title: 'Bachelor & bachelorette eves',
    copy: 'Space for up to ten in the three-bedroom apartment — celebrate together under one roof.',
    icon: 'sparkles',
  },
  {
    id: 'honeymoon',
    title: 'Honeymoons',
    copy: 'Privacy, comfort and refined hospitality for your first days together.',
    icon: 'plane',
  },
  {
    id: 'podcast',
    title: 'Podcast recording',
    copy: 'Calm rooms and generator-backed power for clean, uninterrupted sessions.',
    icon: 'mic',
  },
  {
    id: 'youtube',
    title: 'YouTube & social content',
    copy: '24-hour internet for same-day uploads, and a fresh corner for every video.',
    icon: 'play',
  },
  {
    id: 'family',
    title: 'Family getaways',
    copy: 'Three bedrooms, a pool and room for everyone to settle in.',
    icon: 'family',
  },
]
